var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rv-timeline"},[_c('div',{staticClass:"rv-timeline-data"},_vm._l((_vm.timeArray),function(item){return _c('div',{staticClass:"columns"},[(Number.isInteger(item.num))?_c('h6',{staticClass:"time"},[_vm._v(_vm._s(_vm.getTimelineText(item)))]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }